import { makeStyles } from "@material-ui/styles";
import CommonNavbar from "common/components/CommonNavbar";
import { StoreState } from "common/store/types";
import { LOGOUT_ACTION } from "common/store/user/actions";
import { UserManageable } from "common/store/user/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Logout from "../common/assets/images/logout.svg";
import LogoutHover from "../common/assets/images/logouthover.svg";
import { LanguageSwitch } from "./LanguageSwitch";

const LogoutIcon = (isHovered: boolean) =>
  <img src={isHovered ? LogoutHover : Logout} alt="logout" />
;
const navbarStyle = makeStyles({
  root: {
    zIndex: 2000,
    backgroundColor: "white !important",
    boxShadow: "0px 21.7852px 43.5704px rgba(0, 0, 0, 0.05) !important",
  },
});

export default function Navbar() {
  // Hooks
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const storageUserDetails = useSelector<StoreState, UserManageable>((state) => state.currentUser);

  // Options
  let options = (vertical: boolean) => [
    {
      text: t("Home"),
      visible: () => vertical,
      onClick: () => history.push("/offerings"),
      icon: null,
      className: () =>
        location.pathname === "/offerings" ? "active-item" : "",
    },
    {
      text: t("Dashboard"),
      visible: () => true,
      onClick: () => history.push("/dashboard"),
      icon: null,
      className: () =>
        location.pathname === "/dashboard" ? "active-item" : "",
    },
    {
      text: t("Personal Data"),
      visible: () => true,
      onClick: () => history.push("/personal-data"),
      icon: null,
      className: () =>
        location.pathname === "/personal-data" ? "active-item" : "",
    },
    {
      text: t("Documents"),
      visible: () => true,
      onClick: () => history.push("/documents"),
      icon: null,
      className: () =>
        location.pathname === "/documents" ? "active-item" : "",
    },
    {
      text: t("Logout"),
      visible: () => vertical,
      onClick: () => {
        dispatch({ type: LOGOUT_ACTION });
        history.push("/");
      },
      icon: LogoutIcon,
      className: () => "",
    },
  ];

  const pageName = () => {
    switch (location.pathname) {
      case "/dashboard":
        return t("Dashboard");
      case "/offerings":
        return t("Home");
      case "/personal-data":
        return t("Personal Data");
      case "/kyc":
        return t("Personal Data");
      case "/documents":
        return t("Documents");
      default:
        return "";
    }
  };

  const name = storageUserDetails.firstName
    ? storageUserDetails.firstName
    : "?";

  const classes = navbarStyle();

  return (
    <CommonNavbar
      classes={classes}
      name={name}
      pageName={pageName()}
      homeURL={"/offerings"}
      languageSwitch={<LanguageSwitch />}
      options={options}
    />
  );
}
